import styled, { css } from 'styled-components';
import tokens from '../../../foundation/tokens/js/tokens';
// styled-components.
// -----------------------------------------------------------------------------
export const ControlledTableRowRoot = styled.tr `
  ${({ isSelected }) => {
    return css `
      ${isSelected &&
        `
        > td {
          background-color: ${tokens.colors.active[100].value} !important;
          color: ${tokens.colors.midnight[800].value} !important;
        }
      `}
    `;
}}
`;
//# sourceMappingURL=ControlledRows.styled.js.map